import React, { Component } from 'react';
import { connect } from 'react-redux'
import { reduxForm, formValueSelector } from 'redux-form';
import axios from "axios";

import { Row, Col } from 'react-bootstrap';
import {FormattedHTMLMessage} from 'react-intl';
import CustomSpinner from './CustomSpinner';
import SignatureForm from './SignatureForm';
import ContractContainer from '../containers/ContractContainer.js';


require(`../assets/${process.env.PAGE}/css/components/Contracts.css`)


class Contracts extends Component {

    constructor(props) {
        super(props);
        this.state = {
            contracts: [],
            hasSignature: false,
            signatureRequired: null,
        };

        this.setSignature = this.setSignature.bind(this);
    }

    componentDidMount() {

        const ROOT_URL = process.env.API_URL;
        const config = {
            headers:
                {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
                }
        };

        axios.get(`${ROOT_URL}/leads/contracts`, config)
            .then((response) => {
                this.setState({
                    contracts: response.data.contracts
                });
            });

        axios.get(`${ROOT_URL}/leads/signature`, config)
            .then((response) => {
                this.setState({
                    signatureRequired: response.data.required
                });
            });
    }

    getContracts = () => {
        let contractsForm = [];
        const {myContracts} = this.props;

        for (let index in this.state.contracts){
            let accepted = false;
            let name = this.state.contracts[index].contract_type;
            let label = this.state.contracts[index].title;

            if (name in myContracts){
                accepted =  myContracts[name].values && myContracts[name].values.contract_accepted;
            }

            let contract = <ContractContainer key={index} form={name} onSubmit={this.props.submitContract}
                                              checked={accepted} label={label} />
            contractsForm.push(contract);
        }

        return contractsForm;
    }

    setSignature = (hasSignature) => {
        this.setState({
            hasSignature: hasSignature
        });
    }

    render() {
        const { handleSubmit, acceptedAllContracts } = this.props;
        const { signatureRequired, hasSignature, contracts } = this.state;

        let contractsForm = this.getContracts();

        return (
            <div className="terms text-center">
                {this.props.isLoading &&  <CustomSpinner message='Estamos analizando su solicitud. Por favor espere...' /> }
                <h3>Consentimiento Legal</h3>
                <FormattedHTMLMessage id="app.contract_advice" defaultMessage="<p>Por favor, abrir, leer y acordar.</p>" description="Advice"/>
                {contractsForm}
                {signatureRequired && <SignatureForm onChange={this.setSignature} disabled={ contracts.length === 0  || !acceptedAllContracts}/>}
                <form onSubmit={handleSubmit(this.props.getStep)}>
                    <Row className="terms_row">
                        <Col className="terms_col text-center" xs={12} md={12} lg={12}>
                            <button
                                type="submit"
                                className="btn btn-warning btn-lg pd-button pd-form loan"
                                disabled={(!acceptedAllContracts || (signatureRequired && !hasSignature))}
                            >
                                Finalizar
                            </button>
                        </Col>
                    </Row>
                </form>
            </div>
        );
    }
}

const selectorTos = formValueSelector('tos')

Contracts = connect(
    state => ({
        myContracts: state.form,
        acceptedAllContracts: Object.values(state.form).filter(x =>  x.values && x.values.contract_accepted === false).length === 0
    }),
)(Contracts)

Contracts = reduxForm({
    form: 'Contracts', // a unique name for this form
})(Contracts);


export default Contracts;



/** WEBPACK FOOTER **
 ** ./src/components/Contracts.js
 **/